import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ASpaceInBetweenAnother from '../ASpaceInBetweenAnother/a.space.inbetween.another.vue';

@Component({
    components: {
        ASpaceInBetweenAnother
    }
})
export default class ClientCLogin extends Vue {
    public title: string = 'ClientCLogin';

    @Prop()
    public data: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    public fields: any = {
        username: {
            value: '',
            state: null,
        },
        password: {
            value: '',
            state: null
        },
    };

    public resetModal() {
        // this.fields = {
        //    name: {
        //       value: '',
        //       state: null,
        //    },
        //    remark: {
        //       value: '',
        //       state: null
        //    },
        //    phone: {
        //       value: '',
        //       state: null
        //    },
        //    email: {
        //       value: '',
        //       state: null
        //    }
        // };
    }
}
